var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (user) {
buf.push("<h1 class=\"iq-headline\">");
if ( user.isWithAccount())
{
buf.push("We found an Artsy account associated with" + (jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + "<em>" + (jade.escape((jade_interp = user.get('email')) == null ? '' : jade_interp)) + ".</em>" + (jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + "Please log in to continue.");
}
else
{
buf.push("Please log in to save information to your profile.");
}
buf.push("</h1><form class=\"stacked-form\"><div class=\"iq-form-errors js-form-errors\"></div><label for=\"password\" class=\"avant-garde-form-label\">Enter your password</label><input id=\"password\" name=\"password\" type=\"password\" placeholder=\"Password\" autocomplete=\"on\" pattern=\".{6,}\" title=\"6 characters minimum\" autofocus required class=\"bordered-input\"><button type=\"submit\" class=\"avant-garde-button-black js-form-submit js-login-email\">Log in</button><div class=\"iq-account-sub\"><div class=\"artsy-checkbox\"><div class=\"artsy-checkbox--checkbox\"><input id=\"remember_me\" name=\"remember_me\" type=\"checkbox\" value=\"1\" checked><label for=\"remember_me\"></label></div><label for=\"remember_me\" class=\"artsy-checkbox--label\">Remember me</label></div><span><a data-mode=\"forgot\" class=\"fine-faux-underline js-mode js-forgot-password\">Forgot Password?</a>");
if (!( user.isWithAccount()))
{
buf.push("<span class=\"garamond-tab-separator is-vertical\"></span><a data-mode=\"signup\" class=\"fine-faux-underline js-mode\">Sign up</a>");
}
buf.push("</span></div><div class=\"iq-account-sub\">");
if (!( user.isWithAccount()))
{
buf.push("<a class=\"fine-faux-underline js-iq-save-skip\">No thanks don&rsquo;t save my information</a>");
}
buf.push("</div></form>");}.call(this,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined));;return buf.join("");
};
module.exports = template;